import { getDisplayName } from "./language";
import { specialAreaIds } from "./const";
/**
 * 过滤国家数据
 * @param originData 源数据
 * @param includeList 指定国家列表
 * @param excludeList 排除国家列表
 * @returns
 */
export function handleFilterCoutries(originData, includeList, excludeList, showDisabledDivision) {
  if (includeList === void 0) {
    includeList = [];
  }
  if (excludeList === void 0) {
    excludeList = [];
  }
  var res = [];

  // includeList excludeList同时存在时，includeList优先级更高
  // showDisabledDivision 优先级最高
  for (var i = 0; i <= originData.length - 1; i++) {
    var o = originData[i];
    if (!showDisabledDivision && o.disable) {
      continue;
    }
    if (includeList.length) {
      if (includeList.includes(o.iso)) {
        res.push(o);
      }
      continue;
    }
    if (!excludeList.includes(o.iso)) {
      res.push(o);
    }
  }
  return res;
}

/**
 * 全局过滤数据，已删除数据、跳级数据等
 * @param originData
 * @param props
 * @returns
 */
export function handleFilterDivisions(originData, props) {
  var showDisabledDivision = props.showDisabledDivision;
  // todo isSkipLevelData
  var res = [];
  if (!showDisabledDivision) {
    originData.forEach(function (o) {
      if (o.disable === false) {
        res.push(o);
      }
    });
  } else {
    res = originData;
  }
  return res;
}

/**
 * 过滤显示中国内地或者港澳台数据
 * @param originData 源数据
 * @param props 配置项
 * @returns
 */
// todo 当配置开启时，设置中国文案为 内地或港澳台。且必须显示
export function handleFilterSpicialData(originData, props) {
  var inlandOnly = props.inlandOnly,
    inlandNot = props.inlandNot;
  var res = [];
  if ('inlandOnly' in props && inlandOnly) {
    originData.forEach(function (o) {
      if (!specialAreaIds.includes(o.id)) {
        res.push(o);
      }
    });
    return res;
  }
  if ('inlandNot' in props && inlandNot) {
    originData.forEach(function (o) {
      if (specialAreaIds.includes(o.id)) {
        res.push(o);
      }
    });
    return res;
  }
  return originData;
}

/**
 * 排序
 * @param data 源数据
 * @param divisionSort
 * @param dataLanguage
 * @returns
 */
export function handleSortData(data) {
  // 按字母排序 alphabetical
  return data.sort(function (a, b) {
    var A = a.label;
    var B = b.label;
    return (A || '').localeCompare(B || '');
  });
}

/**
 * 格式化数据为标准组件可接收格式
 * @param originData
 */
export function formatDataToNorm(originData, config) {
  var isHasLeaf = config && 'isLeaf' in config;
  // 处理是否为末级
  // 优先判断maxLevel，其次判断是否该数据本身是末级
  var res = originData.map(function (item) {
    return {
      value: item.id,
      label: getDisplayName(item, config === null || config === void 0 ? void 0 : config.dataLanguage),
      isLeaf: isHasLeaf ? config.isLeaf || item.leaf : item.leaf,
      protoData: item
    };
  });
  return handleSortData(res);
}